var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.68 23.04v10.847h20.645V23.04a.938.938 0 00-.307-.695l-9.385-8.532a.938.938 0 00-1.263 0l-9.383 8.532a.94.94 0 00-.307.695z",
    fill: "#9BAEF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.817 40.63V35a.938.938 0 00-.938-.939h-3.754a.938.938 0 00-.938.938v5.631a.939.939 0 01-.939.939h-5.63a.936.936 0 01-.938-.938V29.785a.938.938 0 01.307-.694l9.384-8.532a.938.938 0 011.262 0l9.385 8.532a.938.938 0 01.307.694v10.846a.938.938 0 01-.938.938h-5.632a.938.938 0 01-.938-.939z",
    fill: "#4A62BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.031 23.04v10.847h20.646V23.04a.938.938 0 00-.307-.695l-9.385-8.532a.938.938 0 00-1.263 0l-9.384 8.532a.94.94 0 00-.307.695z",
    fill: "#2F4491"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.169 40.63V35a.938.938 0 00-.939-.939h-3.754a.938.938 0 00-.938.938v5.631a.938.938 0 01-.938.939H7.97a.936.936 0 01-.939-.938V29.785a.939.939 0 01.307-.694l9.384-8.532a.938.938 0 011.263 0l9.385 8.532a.938.938 0 01.307.694v10.846a.94.94 0 01-.939.938h-5.631a.938.938 0 01-.938-.939z",
    fill: "#1B264F"
  })));
}
export default __webpack_public_path__ + "media/homeProperty/home-fb635762.svg";
export { SvgHome as ReactComponent };